var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.459 400H364.349C358.031 356.705 343.509 316.045 322.33 279.662L281.228 304.322C298.05 333.387 309.589 365.738 315.459 400ZM208.859 221.906C229.439 238.043 248.078 256.498 263.623 277.566L304.931 252.781C284.498 224.297 259.513 199.48 231.38 178.602L208.859 221.906ZM424 432.002H63.527L253.295 67.094C259.404 55.328 254.826 40.846 243.076 34.721C231.279 28.596 216.826 33.158 210.701 44.938L2.699 444.938C-1.161 452.375 -0.864 461.281 3.48 468.469C7.839 475.625 15.605 480 23.996 480H424C437.25 480 448 469.25 448 456S437.25 432.002 424 432.002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.53377204bb89edb63073e5ff53ab7dc4.svg";
export { ForwardRef as ReactComponent };